/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { CartQuery as CartQuerySource } from 'SourceQuery/Cart.query';
import { Field } from 'Util/Query';

/** @namespace Bookland/Query/Cart/Query */
export class CartQuery extends CartQuerySource {
    setShippingAddressesOnCart(shippingAddress) {
        return new Field('setShippingAddressesOnCart')
            .addArgument('input', 'SetShippingAddressesOnCartInput', shippingAddress)
            .addField(new Field('cart').addField('id'));
    }

    setShippingMethod(shippingMethod) {
        return new Field('setShippingMethodsOnCart')
            .addArgument('input', 'SetShippingMethodsOnCartInput', shippingMethod)
            .addField(new Field('cart').addField('id'));
    }

    getRemoveAddressFromCartMutation(cartId) {
        return new Field('removeAddressFromCart')
            .addArgument('cart_id', 'String', cartId);
    }

    getAddProductToCartMutation(cartId, cartItems) {
        return new Field('addProductsToCart')
            .addArgument('cartId', 'String!', cartId)
            .addArgument('cartItems', '[CartItemInput!]!', cartItems)
            .addField(this._getUserErrorsField());
    }

    _getCartTotalsFields() {
        return [
            'id',
            'email',
            'bookstore_pickup_location',
            'carrier_pickup_location',
            this._getPricesField(),
            this._getShippingAddressesField(),
            this._getMinimumOrderAmount(),
            this._getCartItemsField(),
            'total_quantity',
            'is_virtual',
            'is_in_store_pickup_available',
            'free_shipping',
            'bookstore_pickup_location'
        ];
    }

    _getSelectedShippingMethodFields() {
        return [
            'amount_incl_tax',
            'carrier_code',
            'carrier_title',
            'method_code',
            'method_title',
            'tax_amount',
            'pickup_source',
            this._getAmountField(),
            this._getOrderShippingAddressField()
        ];
    }

    _getCartItemPricesFields() {
        return [
            this._getCartItemPriceField(),
            this._getCartItemRowTotalField(),
            this._getCartItemRowTotalInclTaxField(),
            this._getCartItemTotalDiscountField()
        ];
    }

    _getOrderAddressFields() {
        return [
            'city',
            'company',
            this._getCountryField(),
            'firstname',
            'lastname',
            'postcode',
            this._getRegionField(),
            'telephone',
            'vat_id',
            'email',
            'street'
        ];
    }
}

export default new CartQuery();
